import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import Toast from "../components/Toast";
import servicesUtils from "./servicesUtils";
import { getFCMToken, getPlatform, isAndroidWebView, isIOSWebView } from ".";
import Store from "./Store";
import constants from "./constants";
import { t } from "i18next";
export var registerSubscription = function registerSubscription(token) {
  var params = {
    token: token,
    platform: getPlatform()
  };
  return servicesUtils.postService("/subscription/", params).then(function () {
    return true;
  })["catch"](function () {
    Toast.error(t("unable_to_subscribe"));
    return false;
  });
};
export var unRegisterSubscription = function unRegisterSubscription(token) {
  var params = {
    token: token
  };
  return servicesUtils.postService("/subscription/delete/", params);
};
export var subscribeUserNotification = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(RNFcmToken) {
    var token, _window, status, _window2, old_fcmToken, _window3, isSuccess, _window4, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          token = RNFcmToken || null;
          if (!(!token && !isAndroidWebView() && !isIOSWebView())) {
            _context.n = 4;
            break;
          }
          _context.n = 1;
          return (_window = window) === null || _window === void 0 || (_window = _window.Notification) === null || _window === void 0 ? void 0 : _window.requestPermission();
        case 1:
          status = _context.v;
          if (!(status && status === "granted")) {
            _context.n = 3;
            break;
          }
          _context.n = 2;
          return getFCMToken();
        case 2:
          token = _context.v;
          _context.n = 4;
          break;
        case 3:
          if (status && status === "denied") {
            Toast.error(t("allow_browser_permission"));
          }
        case 4:
          if (!token) {
            _context.n = 6;
            break;
          }
          old_fcmToken = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.localStorage.getItem(constants.PERSISTED.fcmToken);
          if (old_fcmToken && token != old_fcmToken) {
            unRegisterSubscription(old_fcmToken);
            (_window3 = window) === null || _window3 === void 0 || _window3.localStorage.removeItem(constants.PERSISTED.fcmToken);
          }
          _context.n = 5;
          return registerSubscription(token);
        case 5:
          isSuccess = _context.v;
          if (isSuccess) {
            (_window4 = window) === null || _window4 === void 0 || _window4.localStorage.setItem(constants.PERSISTED.fcmToken, token);
          }
          if (isSuccess && !RNFcmToken) {
            Store.update(function (s) {
              s.fcmToken = token;
            });
          }
          return _context.a(2, isSuccess);
        case 6:
          return _context.a(2, null);
        case 7:
          _context.p = 7;
          _t = _context.v;
          console.error(_t);
          return _context.a(2, null);
      }
    }, _callee, null, [[0, 7]]);
  }));
  return function subscribeUserNotification(_x) {
    return _ref.apply(this, arguments);
  };
}();